<script>
import { mapActions, mapGetters } from 'vuex';
import Catalogue from '@/services/catalogue';

export default {
    props: {
        company: {
            default:{},
        }
    },
    components: {
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            partners: [],
        }
    },
    methods: {
        closedModal() {
            this.partners = [];
            this.errors = {};
            this.$modal.hide('listPartners');
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    mounted() {
        // if (this.authUser.organization_charts_id != 1) {
        //     this.catalogue.get_companies_users(this.authUser.id);
        // } else {
        //     this.catalogue.get_companies_buildings();
        // }
    },
    created() {
        Event.$on("event-show-listPartners", async () => {
            this.catalogue.get_company_user_partner(this.company.id);
            this.$modal.show('listPartners');
        });
    },
    computed: {
        sum(){
            let sum=0;
            this.catalogue.company_user.forEach(p=>{
                sum+=Math.round(p.pivot.percentage * 1000000)/10000;
            })
            return sum;
        },
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
}
</script>
<template>
    <modal name="listPartners" :width="'80%'" :maxHeight="300" :height="'auto'" v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
            <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                    class="fa-solid fa-xmark"></i> </button>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Listado de Socios</h5>
            </div>
            <div class="modal-body">
                <div class="row">

                    <div class="col-md-6 mt-3">
                        <label>Empresa</label>
								{{ company.name }}
                    </div>

                    <div class="col-12 mt-3">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Socio</th>
                                    <th>Porcentaje</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(user, index_user) in catalogue.company_user" :key="index_user">
                                    <td>
                                        <div v-if="authUser.organization_charts_id==1 || authUser.companies.some((spec, index) => { return spec.id == company.id })">
                                            {{ user.name }} {{ user.last_name }}
                                        </div>
                                        <div v-else>
                                            XXXXXXX XXXXXXXX
                                        </div>
                                    </td>
                                    <td>
                                        {{ Math.round(user.pivot.percentage * 1000000)/10000 }}%
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot v-if="catalogue.company_user.length > 0">
                                <tr class="table-secondary">
                                    <td>
                                        Total :
                                    </td>
                                    <td class="text-right">
                                        {{ sum() }}%
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    <div class="col-md-12">
                        <hr>
                        <button type="button" @click="closedModal()"
                            class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
    </modal>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.image-upload>input {
    display: none;
}

.del {
    position: absolute;
    right: 0px;
    margin: 10px;
}
</style>
